<template>
  <div class="row justify-content-center"  style="margin-top: -8%;">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">
            {{ t('auth.createYourAccount')}}
          </h4>
          <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
          <form  @submit.prevent="register">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">{{ t('auth.companyName')}}</label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. I-MONEY AFRICA"
                v-model="formValues.company_name"
                @blur="validate('company_name')"
                @keypress="validate('company_name')"
                :class="{ 'is-invalid': errorsBis['company_name'] }"
              />                   
              <span class="invalid-feedback">{{ errorsBis['company_name']}}</span>
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.emailAddress')}}
              </label>
              <input
                type="email"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. adam127704@gmail.com"
                v-model="formValues.email"
                @blur="validate('email')"
                @keyup="validate('email')"
                :class="{ 'is-invalid': errorsBis['email'] }"
              />                   
              <span class="invalid-feedback">{{ errorsBis['email']}}</span>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.contact')}}
              </label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. 0500005555"
                v-model="formValues.contact"
                @blur="validate('contact')"
                @change="validate('contact')"
                :class="{ 'is-invalid': errorsBis['contact'] }"
              />  
                <!-- @keyup="validate('contact')" -->                 
              <span class="invalid-feedback">{{ errorsBis['contact']}}</span>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.bankName')}}
              </label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="eX:CORIS BANK"
                v-model="formValues.bankDomiciliation"
                @blur="validate('bankDomiciliation')"
                @change="validate('bankDomiciliation')"
                :class="{ 'is-invalid': errorsBis['bankDomiciliation'] }"
              />  
                <!-- @keyup="validate('contact')" -->                 
              <span class="invalid-feedback">{{ errorsBis['bankDomiciliation']}}</span>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.rib')}}
              </label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="ex: CI0012014551"
                v-model="formValues.rib"
                @blur="validate('rib')"
                @change="validate('rib')"
                :class="{ 'is-invalid': errorsBis['rib'] }"
              />  
                <!-- @keyup="validate('contact')" -->                 
              <span class="invalid-feedback">{{ errorsBis['rib']}}</span>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.cryptoAccount')}}
              </label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="ex: sotac@img.com"
                v-model="formValues.cryptoAccount"
                @blur="validate('cryptoAccount')"
                @change="validate('cryptoAccount')"
                :class="{ 'is-invalid': errorsBis['cryptoAccount'] }"
              />  
                <!-- @keyup="validate('contact')" -->                 
              <span class="invalid-feedback">{{ errorsBis['cryptoAccount']}}</span>
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.password')}}
              </label>
              <input
                type="password"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="**************"
                v-model="formValues.password"
                @blur="validate('password')"
                @keyup="validate('password')"
                :class="{ 'is-invalid': errorsBis['password'] }"
              />                   
              <span class="invalid-feedback">{{ errorsBis['password']}}</span>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.confirmPassword')}}
              </label>
              <input
                type="password"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="**************"
                v-model="formValues.confirm_password"
                @blur="validate('confirm_password')"
                @keyup="validate('confirm_password')"
                :class="{ 'is-invalid': errorsBis['confirm_password'] }"
              />                   
              <span class="invalid-feedback">{{ errorsBis['confirm_password']}}</span>
            </div>

            <div
              class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20"
            >
              <!-- <input
                class="form-check-input shadow-none"
                type="checkbox"
                id="remember-me"
              />
              <label class="form-check-label" for="remember-me">
                J'accepte tout
                <a href="#" class="text-decoration-none">Termes & Conditions</a>
              </label> -->
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100"
              type="submit"
              style="background-color: #EB9355;"
            >
            {{ t('auth.signUpNow')}}
            </button>
            <span
              class="d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
            >
            {{ t('auth.alreadyHaveAccount')}}
            </span>
            <router-link
              to="/"
              class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
            >
            {{ t('auth.loginHere')}} 
            </router-link>
            <!-- <span
              class="d-block or text-muted text-center mt-15 mb-15 mt-md-20 mb-md-20 fs-md-15 fs-lg-16 position-relative z-1 lh-1"
            >
              <span class="d-inline-block bg-white">Or</span>
            </span> -->
            <!-- <ul class="socials ps-0 mb-0 list-unstyled text-center">
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative facebook border-0 p-0"
                >
                  <i class="ph-fill ph-facebook-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative google border-0 p-0"
                >
                  <i class="ph-bold ph-google-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative twitter border-0 p-0"
                >
                  <i class="ph-fill ph-twitter-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative linkedin border-0 p-0"
                >
                  <i class="ph-fill ph-linkedin-logo"></i>
                </button>
              </li>
            </ul> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import router from '@/router';
import axios from 'axios';
import { ref, reactive, inject } from 'vue';
import * as yup from 'yup';
import data from '../../../../env.json'
import { useI18n } from "vue-i18n";

const backApi=inject('back');
const error = ref('');
const errors = ref('');
const errorId = ref('');
const success = ref('');
const { t } = useI18n();
const errorsBis = {
  'email':'',
  'password':'',
  'confirm_password':'',
  'company_name':'',
  'contact':'',
  'bankDomiciliation':'',
  'rib':'',
  'cryptoAccount':''
};

const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const ACCOUNT_TYPE = 'WEB';

const schema = yup.object({
    password: yup.string()
        .required(t('validationform.passwordRequired'))
        .min(6, t('validationform.passwordMinLength6')),

    confirm_password: yup.string()
        .required(t('validationform.confirmPasswordRequired'))
        .min(6, t('validationform.confirmPasswordMinLength6'))
        .oneOf([yup.ref('password'), null], t('validationform.passwordMustMatch')),

    email: yup.string()
        .email(t('validationform.emailValid'))
        .required(t('validationform.emailRequired')),
    company_name: yup.string()
        .required(t('validationform.companyNameRequired')),
    //name: yup.string().required(t('validationform.nameRequired')),
    contact: yup.string()
        .required(t('validationform.phoneRequired'))
        .matches(phoneRegExp, t('validationform.phoneValid'))
        .test('len', t('validationform.phoneLength'), val => val.length === 10),
    bankDomiciliation: yup.string()
        .required(t('validationform.bankNameRequired')),
    rib: yup.string(),
    cryptoAccount: yup.string(),
});


const formValues = reactive({
  email: "",
  password: "",
  confirm_password: "",  
  company_name: "",  
  contact: "",
  bankDomiciliation: "",
  rib: "",
  cryptoAccount: ""
});

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;
        });
        errors.value=''
    }


const register = async () => {
  
      try {  
        schema.validateSync(formValues);

        const payload = {
          email: formValues.email,
          name: formValues.company_name,
          contact: formValues.contact,
          description: formValues.company_name,
          bankDomiciliation: formValues.bankDomiciliation,
          rib: formValues.rib,
          cryptoAccount: formValues.cryptoAccount,
          type: "LEGAL",
          userType: ACCOUNT_TYPE,
          password: formValues.password,
        };

        console.log('actionsociale@gmail.com===type==',payload)
        axios.post(backApi+'/public/organizations/new', payload, {
        headers: {          
          'Content-Type': 'application/json',           
        }
      }).then((response) => {
        if(response.status === 200){
            success.value = t('validationform.registrationSuccess');
            setTimeout(() => {
              router.push('/');
            }, 1500);
        }
      }).catch((error) => {
          if( error.response){  
              errorId.value=error.response.data.errorId;            
              errors.value=error.response.data.message;              
          }
      });
        

      } catch (error) {
        console.error(error);
        
         errors.value="une erreur inattendue est apparue"
      
      }
 
};

</script>